import { render, staticRenderFns } from "./ObchodniPripadList.vue?vue&type=template&id=ed673e1c&"
import script from "./ObchodniPripadList.vue?vue&type=script&lang=ts&"
export * from "./ObchodniPripadList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports